import styled from 'styled-components';

export const Container = styled.div``;

export const Content = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 26px;
`;
